import React from 'react'
import ComputerSpecialistForm from './ComputerSpecialistForm'

export default function ComputerCreateSpecialistAppointmentPage ({ loading, onFinishFailed, sort, minimumAge, onFinish, civilityOptions, initialValues }) {
  return (
    <ComputerSpecialistForm
      loading={loading}
      onFinishFailed={onFinishFailed}
      sort={sort}
      minimumAge={minimumAge}
      onFinish={onFinish}
      civilityOptions={civilityOptions}
      initialValues={initialValues}
    />
  )
}
